import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import MarketplaceApplyNow, { APPLY_NOW_LINK_TYPES, LINK_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import MarketplaceStarRating from '@nerdwallet/react-marketplace-star-rating';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { TRK_PRODUCT_LOCATION, COMPONENT_ANALYTICS_NAME } from '../lib/constants';
import { buildTrkSectionCategory, getMonetizable } from '../lib/utils';
import BaseHeader from './base-header';
/**
 * @deprecated
 */
var MappedHeader = function MappedHeader(_ref) {
  var analytics = _ref.analytics,
    className = _ref.className,
    ctaHref = _ref.ctaHref,
    _ref$displayPage = _ref.displayPage,
    displayPage = _ref$displayPage === void 0 ? '' : _ref$displayPage,
    enableAnalytics = _ref.enableAnalytics,
    heading = _ref.heading,
    marketplaceEntity = _ref.marketplaceEntity,
    _ref$omitCta = _ref.omitCta,
    omitCta = _ref$omitCta === void 0 ? false : _ref$omitCta,
    _ref$omitRating = _ref.omitRating,
    omitRating = _ref$omitRating === void 0 ? false : _ref$omitRating,
    _ref$omitRatingTextHr = _ref.omitRatingTextHref,
    omitRatingTextHref = _ref$omitRatingTextHr === void 0 ? false : _ref$omitRatingTextHr,
    productType = _ref.productType,
    reviewLinkHref = _ref.reviewLinkHref,
    shouldLogImpression = _ref.shouldLogImpression,
    starRating = _ref.starRating,
    taxonomy = _ref.taxonomy,
    trkPageType = _ref.trkPageType,
    trkProductPosition = _ref.trkProductPosition,
    trkSectionCategory = _ref.trkSectionCategory;
  useDeprecatedPropsWarning({
    component: 'ProductCardHeader',
    deprecatedProps: [{
      version: '6.9.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  var impressionContext = useContext(ImpressionContext);
  var passThroughProps = {
    analytics: analytics || enableAnalytics && {},
    className: className,
    heading: heading,
    shouldOmitCta: omitCta,
    shouldOmitRating: omitRating
  };
  return /*#__PURE__*/React.createElement(BaseHeader, _extends({}, passThroughProps, {
    applyNowNode: /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
      id: "".concat(TRK_PRODUCT_LOCATION, "__product-name-").concat(trkProductPosition),
      impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
      link: ctaHref,
      linkType: APPLY_NOW_LINK_TYPES.productName,
      marketplaceEntity: marketplaceEntity,
      monetizable: getMonetizable(marketplaceEntity),
      productLocation: TRK_PRODUCT_LOCATION,
      productPosition: trkProductPosition,
      reviewLink: reviewLinkHref,
      sectionName: (analytics === null || analytics === void 0 ? void 0 : analytics.sectionName) || COMPONENT_ANALYTICS_NAME,
      shouldLogImpression: shouldLogImpression,
      trkPageType: trkPageType,
      trkSectionCategory: buildTrkSectionCategory(trkSectionCategory, 'productName'),
      trkTaxonomy: taxonomy,
      type: LINK_TYPES.LINK
      // BNK specific props.
      ,
      displayPage: displayPage,
      disableBankCtaAnnotation: true
    }),
    starRatingNode: /*#__PURE__*/React.createElement(MarketplaceStarRating, {
      analytics: analytics,
      enableAnalytics: enableAnalytics,
      marketplaceEntity: marketplaceEntity,
      omitRatingTextHref: omitRatingTextHref,
      productType: productType,
      ratingTextHref: reviewLinkHref,
      starRating: starRating,
      trkLocation: TRK_PRODUCT_LOCATION // TODO stop passing this through
      ,
      trkPageType: trkPageType,
      trkTaxonomy: taxonomy
    })
  }));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  var PropTypes = require('prop-types');
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  var _require = require('../prop-types'),
    AnalyticsPropType = _require.AnalyticsPropType,
    TRKPropTypes = _require.TRKPropTypes;
  MappedHeader.propTypes = {
    analytics: AnalyticsPropType,
    className: PropTypes.string,
    ctaHref: PropTypes.string,
    enableAnalytics: PropTypes.bool,
    heading: PropTypes.node.isRequired,
    marketplaceEntity: PropTypes.object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    omitCta: PropTypes.bool,
    omitRating: PropTypes.bool,
    omitRatingTextHref: PropTypes.bool,
    productType: PropTypes.string,
    reviewLinkHref: PropTypes.string,
    shouldLogImpression: PropTypes.bool,
    starRating: PropTypes.number,
    taxonomy: TRKPropTypes,
    trkPageType: PropTypes.string,
    trkProductPosition: PropTypes.number,
    trkSectionCategory: PropTypes.string,
    // BNK specific props.
    displayPage: PropTypes.string
  };
}
export default MappedHeader;